import type { User } from '../types';
import './Header.css';

interface HeaderProps {
  presets?: string[];
  selectedPreset?: string;
  onPresetChange?: () => void;
  onUndo?: () => void;
  onRedo?: () => void;
  canUndo?: boolean;
  canRedo?: boolean;
  user?: User | null;
  onLogout?: () => void;
}

export function Header({
  selectedPreset = 'No preset selected',
  onPresetChange,
  onUndo,
  onRedo,
  canUndo = false,
  canRedo = false,
  user,
  onLogout,
}: HeaderProps) {
  return (
    <header className="app-header">
      <div className="header-brand">
        <div className="brand-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </div>
        <div className="brand-text">
          <span className="brand-sub">VYBE</span>
          <span className="brand-main">SOUND</span>
        </div>
      </div>

      <div className="header-center">
        <button className="preset-selector" onClick={onPresetChange}>
          <span className="preset-label">Model:</span>
          <span>{selectedPreset}</span>
          <svg viewBox="0 0 24 24" fill="currentColor" className="preset-arrow">
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </button>
      </div>

      <div className="header-actions">
        <button
          className="action-btn"
          onClick={onUndo}
          disabled={!canUndo}
          title="Undo"
        >
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
          </svg>
        </button>
        <button
          className="action-btn"
          onClick={onRedo}
          disabled={!canRedo}
          title="Redo"
        >
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" />
          </svg>
        </button>
        {user && (
          <div className="user-menu">
            <span className="user-email">{user.email}</span>
            <button className="action-btn logout-btn" onClick={onLogout} title="Logout">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
            </button>
          </div>
        )}
      </div>
    </header>
  );
}







